<!-- 旅居 -->
<template>
  <div class="frame">
    <titleBox
      :title="$t('message.investment.title')"
      :desc="$t('message.investment.subTitle')"
    ></titleBox>
    <div class="content">
      <div class="show_list">
        <div class="show" v-for="item in contentArr" :key="item.id">
          <div class="post">
            <img :src="item.post" alt="" />
          </div>
          <div class="show_desc">
            <div class="type">{{ $t(item.type) }}</div>
            <div class="title">{{ $t(item.title) }}</div>
            <div class="desc">{{ $t(item.desc) }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
  
<script>
export default {
  data() {
    return {
      activeItem: 0,
      contentArr: [
        {
          id: 0,
          post: require("@/assets/invest1.jpeg"),
          type: "message.investment.type1.title",
          title: "message.investment.type1.subTitle",
          desc: "message.investment.type1.desc",
        },
        {
          id: 1,
          post: require("@/assets/invest2.jpeg"),
          type: "message.investment.type2.title",
          title: "message.investment.type2.subTitle",
          desc: "message.investment.type2.desc",
        },
        {
          id: 2,
          post: require("@/assets/invest3.jpeg"),
          type: "message.investment.type3.title",
          title: "message.investment.type3.subTitle",
          desc: "message.investment.type3.desc",
        },
        {
          id: 3,
          post: require("@/assets/invest4.jpeg"),
          type: "message.investment.type4.title",
          title: "message.investment.type4.subTitle",
          desc: "message.investment.type4.desc",
        },
        {
          id: 4,
          post: require("@/assets/invest5.jpeg"),
          type: "message.investment.type5.title",
          title: "message.investment.type5.subTitle",
          desc: "message.investment.type5.desc",
        },
      ],
    };
  },
  created() {},
  mounted() {},
  methods: {
    changeItem(val) {
      this.activeItem = val;
    },
    navTo(val) {
      this.$router.push(val);
    },
  },
};
</script>
<style lang='scss' scoped>
.content {
  width: 100%;
  max-width: 1200px;
  margin: 45px auto 60px;
  font-size: 14px;
  padding: 0 16px;
  box-sizing: border-box;

  .show_list {
    padding: 10px 0;
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;

    .show {
      width: calc(50% - 8px);
      max-width: 585px;
      height: auto;
      min-height: 250px;
      margin-bottom: 16px;
      position: relative;
      display: flex;
      background-color: #fff;

      .post {
        width: 250px;
        height: 250px;
        overflow: hidden;
        position: relative;
        flex-shrink: 0;

        img {
          width: auto;
          height: 100%;
          position: absolute;
          top: 0;
          left: 50%;
          transform: translateX(-50%);
        }
      }

      .show_desc {
        padding: 12px 20px 0;
        box-sizing: border-box;
        position: relative;
        line-height: 1.6;
        font-size: 16px;

        .type {
          width: 140px;
          height: 35px;
          color: #fff;
          background-color: $theme;
          text-align: center;
          line-height: 35px;
          margin-top: 6px;
        }

        .title {
          font-weight: bold;
          margin-top: 10px;
        }
        .desc {
          margin-top: 10px;
          font-size: 14px;
          color: #666;
          line-height: 25px;
        }
      }
    }
  }
}

@include respond-md {
  .content {
    margin-top: 24px;
    margin-bottom: 40px;

    .show_list {
      .show {
        width: 100%;
        max-width: none;
        flex-direction: column;

        .post {
          width: 100%;
          height: 200px;
        }

        .show_desc {
          padding: 16px;

          .desc {
            line-height: 1.8;
          }
        }
      }
    }
  }
}
</style>